var StateModel = Backbone.Model.extend({
  defaults: {
    filters: {}
  },

  getFilters: function() {
    return this.get("filters");
  }
});

var FilterEnhancedView = require("../../cruise/modules/_search-results-enhanced.filters");

var SearchResultsEnhancedView = require("../../cruise/modules/_search-results-enhanced.view");

var SearchResultsEnhanced = Backbone.View.extend({
  initialize: function() {
    var stateModel = new StateModel();

    new SearchResultsEnhancedView({
      el: this.$el,
      FilterView: new FilterEnhancedView({
        el: this.$el,
        stateModel: stateModel
      }),
      StateModel: stateModel
    });

    this.$el.loadModules();
  }
});

module.exports = SearchResultsEnhanced;
